import { fetchFullOverlayDataQuery } from '@ligr/shared/lib/Overlay/gql/queries/overlay';
import { overlaySubscription } from '@ligr/shared/lib/Overlay/gql/subscriptions/overlay';
import { createContainer } from 'unstated-next';
import { useLazyQuery, useSubscription } from '@apollo/react-hooks';
import { useEffect } from 'react';
export const useOverlay = (initialState) => {
    // useQuery(heartbeatQuery, { variables: { key: overlay.key }, pollInterval: 10_000 });
    var _a, _b;
    const [fetchOverlayWithMatch, overlayQueryResult] = useLazyQuery(fetchFullOverlayDataQuery, {
        fetchPolicy: 'network-only'
    });
    const overlaySub = useSubscription(overlaySubscription, { variables: { id: (_a = initialState === null || initialState === void 0 ? void 0 : initialState.overlay) === null || _a === void 0 ? void 0 : _a.id } });
    // Initial Data Load
    useEffect(() => {
        var _a;
        if (overlaySub.loading) {
            fetchOverlayWithMatch({ variables: { key: (_a = initialState === null || initialState === void 0 ? void 0 : initialState.overlay) === null || _a === void 0 ? void 0 : _a.key } });
        }
    }, [overlaySub.loading]);
    // make this not have nestings
    return {
        manualState: (initialState === null || initialState === void 0 ? void 0 : initialState.manualState) || ((_b = overlayQueryResult.data) === null || _b === void 0 ? void 0 : _b.overlay.manualGraphicState),
        match: overlayQueryResult.data ? overlayQueryResult.data.overlay.match : undefined,
        overlay: overlayQueryResult.data
            ? Object.assign(Object.assign({}, overlayQueryResult.data.overlay), initialState === null || initialState === void 0 ? void 0 : initialState.overlaySettings) : undefined
    };
};
export const OverlayContainer = createContainer(useOverlay);
//# sourceMappingURL=overlayContainer.js.map